<div class="severity">
  <app-tooltip placement="top" [disabled]="tooltipDisabled()">
    <app-icon
      popover-trigger
      [attr.role]="showDescription() ? null : 'img'"
      [attr.aria-label]="showDescription() ? null : (ariaLabel() ?? (alertSeverityKey() | translate))"
      [path]="iconPath()"
      [size]="size()"
      img="true"
    ></app-icon>
    <span class="tooltip typography-small-regular">{{ alertSeverityKey() | translate }}</span>
  </app-tooltip>

  @if (showDescription()) {
    <span class="typography-small-regular">{{ alertSeverityKey() | translate }}</span>
  }
</div>
